const __WEBPACK_NAMESPACE_OBJECT__ = require("rc-picker/es/locale/en_US");